"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 3.4c-1.53 0-2.783 1.255-2.783 2.817V8.7a.7.7 0 1 1-1.4 0V6.217C3.817 3.894 5.683 2 8 2c.815 0 1.578.236 2.222.643a.7.7 0 0 1-.749 1.183A2.74 2.74 0 0 0 8 3.4m3.483 3.4a.7.7 0 0 1 .7.7v1.061c0 .369.166.715.447.944l.18.145c1.031.837.462 2.542-.894 2.542H8.003l-.747.006a.7.7 0 0 1-.012-1.4L8 10.792h3.926a.1.1 0 0 0 .01-.018.1.1 0 0 0 .003-.024v-.001l-.012-.012-.179-.145a2.62 2.62 0 0 1-.965-2.03V7.5a.7.7 0 0 1 .7-.7M6.14 13.3a.7.7 0 0 1 .7-.7h2.32a.7.7 0 1 1 0 1.4H6.84a.7.7 0 0 1-.7-.7m7.555-10.995a.7.7 0 0 1 0 .99l-10.4 10.4a.7.7 0 0 1-.99-.99l10.4-10.4a.7.7 0 0 1 .99 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BellAlertOffIcon16.js.map